// extracted by mini-css-extract-plugin
module.exports = {"button":"index-shimmer_button__Ik2bK","placeholderShimmer":"index-shimmer_placeholderShimmer__3ZooD"};